import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useSite } from "../lib/site";
import { useT } from "../lib/i18n";

export function track(event, params = {}) {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event, ...params });
  if (window.gtag) window.gtag("event", event, params);
}

export function Analytics() {
  const { ga4_id } = useSite();
  const { pathname } = useLocation();
  const [consent, setConsent] = useState(() => localStorage.getItem("analytics_consent"));
  const { t } = useT();

  useEffect(() => {
    if (consent !== "granted" || !ga4_id || window.gtag) return;
    const s = document.createElement("script");
    s.async = true;
    s.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(ga4_id)}`;
    document.head.appendChild(s);
    window.dataLayer = window.dataLayer || [];
    window.gtag = function gtag() { window.dataLayer.push(arguments); };
    window.gtag("js", new Date());
    window.gtag("config", ga4_id, { anonymize_ip: true });
  }, [consent, ga4_id]);

  useEffect(() => {
    track("page_view_spa", { page_path: pathname });
    if (pathname.startsWith("/become-a-solar-partner") || pathname.startsWith("/partner-plans")) track("partner_programme_viewed", { page_path: pathname });
  }, [pathname]);

  const choose = (v) => { localStorage.setItem("analytics_consent", v); setConsent(v); };
  if (consent || pathname.startsWith("/dashboard")) return null;
  return (
    <div className="fixed bottom-4 inset-x-4 md:left-auto md:right-6 md:max-w-md z-50 bg-white border shadow-lg rounded-xl p-4 text-sm" role="dialog" aria-label={t("cookie.label")} data-testid="cookie-banner">
      <p className="text-slate-700">{t("cookie.text")} <a href="/cookie-policy" className="underline">{t("cookie.info")}</a></p>
      <div className="flex gap-2 mt-3">
        <button onClick={() => choose("granted")} className="bg-[#0B1B3D] text-white px-4 py-2 rounded-lg font-semibold" data-testid="cookie-accept">{t("cookie.accept")}</button>
        <button onClick={() => choose("denied")} className="border px-4 py-2 rounded-lg font-semibold" data-testid="cookie-decline">{t("cookie.decline")}</button>
      </div>
    </div>
  );
}
